import { ListTemplateMessages, ListTemplateMessagesVariables } from './__generated__/ListTemplateMessages'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListTemplateMessages($input: ListTemplateMessagesInputV2!) {
    listTemplateMessages: listTemplateMessagesV2(input: $input) {
      templateMessages {
        id
        isFeatured
        attribution
        categoryId
        created
        likes
        message {
          id
          characters
          text
          tags
          cardSize
        }
      }
      nextCursor
    }
  }
`

export const useListTemplateMessages = (variables: ListTemplateMessagesVariables, skip?: boolean) => {
  return useQuery<ListTemplateMessages, ListTemplateMessagesVariables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables
  })
}
